var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: {
        "enter-active-class": "card__dropdown--enter",
        "leave-active-class": "card__dropdown--leave"
      }
    },
    [
      _vm.displayAnimation
        ? _c("div", { staticClass: "card", attrs: { id: "facturasVenta" } }, [
            _c("div", { staticClass: "card__title mb-3" }, [
              _c("h5", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c("div", { staticClass: "card__controls" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.option,
                        expression: "option"
                      }
                    ],
                    attrs: { name: _vm.nameOption, type: "radio", value: "C" },
                    domProps: { checked: _vm._q(_vm.option, "C") },
                    on: {
                      change: function($event) {
                        _vm.option = "C"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Cantidades")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.option,
                        expression: "option"
                      }
                    ],
                    attrs: { name: _vm.nameOption, type: "radio", value: "M" },
                    domProps: { checked: _vm._q(_vm.option, "M") },
                    on: {
                      change: function($event) {
                        _vm.option = "M"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Montos")])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                  _c("div", { staticClass: "graph-box" }, [
                    _c(
                      "div",
                      { staticClass: "graph-box__content" },
                      [
                        _c("column-chart", {
                          attrs: {
                            data:
                              _vm.option === "M"
                                ? _vm.dataChartMontoElect
                                : _vm.dataChartCantElect
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "graph-box__info" }, [
                      _c("span", { staticClass: "graph-box__title" }, [
                        _c("i", { staticClass: "fa fa-file-text" }),
                        _vm._v("Electrónicas\n              ")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "graph-box__values" }, [
                        _vm._v(
                          _vm._s(
                            "Total: " +
                              (_vm.option === "M"
                                ? "$" + _vm.totalMontoElect
                                : "" + _vm.totalCantElect)
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                  _c("div", { staticClass: "graph-box" }, [
                    _c(
                      "div",
                      { staticClass: "graph-box__content" },
                      [
                        _c("column-chart", {
                          attrs: {
                            data:
                              _vm.option === "M"
                                ? _vm.dataChartMontoManual
                                : _vm.dataChartCantManual
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "graph-box__info" }, [
                      _c("span", { staticClass: "graph-box__title" }, [
                        _c("i", { staticClass: "fa fa-pencil" }),
                        _vm._v("Manuales\n              ")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "graph-box__values" }, [
                        _vm._v(
                          _vm._s(
                            "Total: " +
                              (_vm.option === "M"
                                ? "$" + _vm.totalMontoManual
                                : "" + _vm.totalCantManual)
                          )
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75f18d18", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75f18d18","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/TransitionCharts.vue
// module id = 306
// module chunks = 0